import { Page } from './utils/enums'

export const isServer = () => {
  try {
    return !window
  } catch (_) {
    return true
  }
}

declare global {
  interface Window {
    Cypress: object
  }
}

export const isTest = () =>
  process.env.NODE_ENV === 'test' ||
  process.env.NODE_ENV === 'e2e' ||
  (!isServer() && window?.Cypress)

export const isDev = () => process.env.NODE_ENV === 'development'

export const generateUniqueId = () => {
  if (isServer()) return
  const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0]
  return uint32.toString(16)
}

export const setPageTitle = (title: string | undefined) =>
  title && !isServer() ? (document.title = title) : undefined

// Checks if supplied string is a valid page route and returns it as such
export const asPage = <T extends Record<string, string>>(
  s: string,
  pages: T,
  routeMap: Record<string, unknown>,
): Page => {
  if (Object.values(pages).includes(s) && Object.keys(routeMap).includes(s)) {
    return s as Page
  } else {
    throw `${s} is not a route`
  }
}
